export default function(resource_id, course_id, showDiscount) {
  const self = this;
  self.$el = $('#js-resource-coupon-view');
  self.couponCode = ko.observable();
  self.copied = ko.observable(false);

  self.initUI = function() {
    if (showDiscount) {
      self.getDiscount();
    }
  };

  self.goPremium = function() {
    $('#js-premium-required-for-coupon-modal').modal('show');
  };

  self.showCouponForm = function() {
    $('#js-coupon-form').modal('show');
  };

  self.showServiceError = function() {
    $('#js-coupon-service-error-modal').modal('show');
  };

  self.getDiscount = function() {
    let urlParams = {
      resource_id: resource_id,
      course_id: course_id
    };
    let url = Kadenze.Routes.course_resource_coupon_redemptions_path(urlParams);
    let method = 'POST';

    Kadenze.UIUtil.makeRequest(url, method, {}, self.$el,
      function(xhr, settings) { //BeforeSave
        Kadenze.UIUtil.showLoadingIndicator(self.$el);
      },
      function(data, textStatus, xhr) { //Success
        if (data.coupon_code) {
          self.couponCode(data.coupon_code);
          let $modal = self.$el.find('#js-coupon-redemption-modal');
          $modal.modal('show');
          $modal.one('shown.bs.modal', function(){
            self.$el.find('.resource__coupon_code').select();
            try {
              let successful = document.execCommand('copy');
              let msg = successful ? 'successful' : 'unsuccessful';
              if (successful) {
                self.copied(true);
              }
              console.log('Coupon Redemption: Copying text command was ' + msg);
            } catch (err) {
              console.log('Coupon Redemption: Copying text command was unsuccessful');
            }
          });
        } else {
          Kadenze.UIUtil.showNotice(self.$el, Kadenze.I18n.t('coupons.could_not_retrieve'), 3000);
        }
      },
      function(xhr, textStatus, errorThrown) { //Error
        $('#js-premium-required-for-coupon-modal').modal('show');
      },
      function(xhr, textStatus) { //Complete
        Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      });
  };

  self.generateCode = self.getDiscount;
}
